import React from "react";
import "./uni.css";
import { useNavigate } from "react-router-dom";


export default function Russia() {
  const Navigate = useNavigate()

  return (
    <div className="vbgy">
      <div className="dfhtu">
        <h2>MBBS in KYRGYZSTAN</h2>
      </div>
      <div className="wityu">
        <img src="https://itcslimited.com/wp-content/uploads/2021/06/blog-oldest-medical-russia-banner.jpg"></img>

        <p>
          Kyrgyzstan, formally known as the Kyrgyz Republic ua a beautiful
          country located in central Asia Kyryzstan is known for its natural
          beauty and varied traditions. The Kyrgyz Republic is a landlocked
          Country , covered by mountains sharing its border with Kazakhstan to
          the north Uzbekistan to the west.Tajikistan to the southwest,and china
          to the south east . The capital of Kyrgyzstan is Bishkek which is the
          largest city in the country.Bishkek covers a total area of 49 square
          miles with an estimated population of about 1,250,000 . Kyrgyzstan was
          occupied by Russia in 1876 and in the yesr 1991 , the country
          successfully achieved its independence from the soviet union.
          <br />
          <br />
          <button onClick={()=>{Navigate('/contact')}}>Apply Now</button>
        </p>
      </div>

      {/* 00000000000000000000000000000000000000000000000000000 */}

      <div className="nffd">
        <img src="https://www.7skyconsultancy.com/assets/images/Russia.png"></img>
        <div className="nhjip">
          <h3
            style={{
              backgroundColor: "#ff9818",
              padding: "10px",
              borderRadius: "10px",
            }}
          >
            A BRIEF LOOK AT MBBS In KYRGYZSTAN
          </h3>
          <br />
          <br />
          <table className="ewrfd">
            <tr>
              <td>Capital</td>
              <td>Bishkek</td>
            </tr>
            <tr>
              <td>Population</td>
              <td>65.9 lakhs(2020)</td>
            </tr>
            <tr>
              <td>Language</td>
              <td>
                Kyrgyz (National/State language) Russian (Official and
                lnterethnic)
              </td>
            </tr>
            <tr>
              <td>Medium of Instruction</td>
              <td>English</td>
            </tr>
            <tr>
              <td>Currency</td>
              <td>Som(1 som = 0.99 INR)</td>
            </tr>
            <tr>
              <td>International Airport</td>
              <td>Bishkek</td>
            </tr>
            <tr>
              <td>Recognition</td>
              <td>NMC (MCI), WHO, ECFMG, FAIMER, WDOMS</td>
            </tr>
            <tr>
              <td>Course Duration</td>
              <td>6 Years(5 + 1 Year's internship)</td>
            </tr>
            <tr>
              <td>Average cost of stay (Fee included)</td>
              <td>15-20 lakhs(Approx)</td>
            </tr>
            <tr>
              <td>Intake</td>
              <td>Summer & Winter</td>
            </tr>
            <tr>
              <td>Accomodation Facilities</td>
              <td>Hostel & Apartment</td>
            </tr>
            <tr>
              <td>Indian Mess</td>
              <td>Available</td>
            </tr>
          </table>
        </div>
      </div>

      {/* 0000000000000000000000000000000000000000000000000000000000000000000000    */}
      <div className="cxdsf">
        <div className="ugvuids">
          <h2>UNIVERSITY OF KYRGYZSTAN</h2>
          <table
            className="table"
            data-aos="zoom-in-up"
            data-aos-duration="1000"
            data-aos-easing="linear"
          >
            <tr>
              <th className="th title2">UNIVERSITY NAME</th>
              <th className="th title2">TUTION FEE</th>
              <th className="th title2">HOSTAL FEE</th>
              <th className="th title2">OTC</th>
              <th className="th title2">TOTAL IN 1ST YEAR</th>
              <th className="th title2">INCENTIVE</th>
            </tr>
            {/* <!-- 1 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>1.</span>Asian Medical Institute
              </td>
              <td className="td">2500$ </td>
              <td className="td">500</td>
              <td className="td">2000$</td>
              <td className="td">5000$</td>
              <td className="td">1000$</td>
            </tr>
            {/* <!-- 2 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>2.</span>Bishkek International Medical University
              </td>
              <td className="td">3500$</td>
              <td className="td">800$</td>
              <td className="td">2000$</td>
              <td className="td">6300$</td>
              <td className="td">1000$</td>
            </tr>
            {/* <!-- 3 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>3.</span>International School of Medicine
              </td>
              <td className="td">5000$</td>
              <td className="td">1000$</td>
              <td className="td">2500$</td>
              <td className="td">8500$</td>
              <td className="td">900$ </td>
            </tr>

            {/* <!-- 4 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>4.</span>International Medical University
              </td>
              <td className="td">3500$</td>
              <td className="td">800$</td>
              <td className="td">1500$</td>
              <td className="td">5800$</td>
              <td className="td">1000$ </td>
            </tr>

            {/* <!-- 5 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>5.</span>Jalal-Abad State Medical University
              </td>
              <td className="td">4000$</td>
              <td className="td">600$</td>
              <td className="td">2500$</td>
              <td className="td">7100$</td>
              <td className="td">1000$ </td>
            </tr>

            {/* <!-- 6 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>7.</span>Kyrgyz Russian Slavic University
              </td>
              <td className="td">$</td>
              <td className="td">$</td>
              <td className="td">$</td>
              <td className="td">$</td>
              <td className="td">$</td>
            </tr>

            {/* <!-- 7 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>7.</span>Kyrgyz State Medical Academy
              </td>
              <td className="td">3500$</td>
              <td className="td">600$</td>
              <td className="td">2000$</td>
              <td className="td">6100$</td>
              <td className="td">1000$</td>
            </tr>

            {/* <!-- 8 --> */}
            <tr>
              <td className="td dflex dflexMob">
                <span>8. </span>Osh State Medical University
              </td>
              <td className="td">3500$</td>
              <td className="td">700$</td>
              <td className="td">2000$</td>
              <td className="td">6200$</td>
              <td className="td">1000$ </td>
            </tr>
          </table>
        </div>
      </div>
      <section className="ugvui">
        <ul>
          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="00"
            data-aos-easing="linear"
          >
            Above Mentioned Tution Fee Chargable According to Their Academic
            Session.
          </li>

          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="00"
            data-aos-easing="linear"
          >
            Admission Fee, Documentation & VISA Processing will be Extra.
          </li>

          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="00"
            data-aos-easing="linear"
          >
            Form 2nd to 6th year's Medical Insurance & VISA Extension will be
            Extra (200$).
          </li>

          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="00"
            data-aos-easing="linear"
          >
            Flight Ticket Charge Excluded.
          </li>

          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="00"
            data-aos-easing="linear"
          >
            Indian Mess Food 120$ Per Month Extra.
          </li>

          <li
            className="para"
            data-aos="fade-down"
            data-aos-duration="00"
            data-aos-easing="linear"
          >
            <span>
              <b>Note:</b>
            </span>
            <br />
            In certain case students have to pay either partial or full amount
            of tuition fee to the university soon after receive letter, as per
            the University instruction
          </li>
        </ul>
      </section>

      {/* 0000000000000000000000000000000000000000000000000000000000000000000000 */}

      <div className="gsfas">
        <h3>BISHKEK INTERNATIONAL MEDICAL UNIVERSITY</h3>

        <div className="sdgdfghf">
          <img src="https://pbs.twimg.com/media/FwhwhFKWcAAjWfd?format=jpg&name=large"></img>
          <p>
            The Bishkek International Medical Institute (BIMI) was founded in
            2019. BIMI offers the opportunity to study in one of the modern
            educational medical centers in Kyrgyzstan and Central Asia. The
            students encouraged to build their knowledge based on the high
            qualified teaching staff and excellent teaching base on the
            practical skills within BIMI medi­ cal clinics. BIMI offers
            education, based on the authors technologies teaching by highly
            qualified academic staff teachers; a lot of attention is paid to
            developing practical skills for future doctors; up to day well
            equipped modern computer simulation center; and other modern
            educational technologies.
            <br />
            <strong>ESTO. : 2004</strong>
            <br />
            <strong>University Type : Government</strong>
            <br />
            <strong>Medium : English</strong>
            <br />
            <strong>ESTO. : No. of Indian Students : 500+</strong>
            <br />
          </p>
        </div>
      </div>

      {/* 0000000000000000000000000000000000000000000000000 */}

      <div className="packageForFirstYear">
        <table className="table fgjhfghfg" border="1">
          <h2 style={{ textAlign: "center", width: "100%" }}>
            PACKAGE FOR 1ST YEAR STUDENT
          </h2>
          <thead>
          <tr >
                        <td className="td">TUITION FEE</td>
                        <td className="td">HOSTEL FEE</td>
                        <td className="td td2">IMMIGRATION CLERANCE,AIRPORT PICKUP, ARRIVAL MEAL, TRANSLATION AND ATTESTATION OF DOCUMENTS IN UNIVERSITY, MEDICAL INSURANCE & MEDICAL CHECKUP, LOCAL POLICE VERIFICATION, BIOMETRIC AND VISA EXTENTION, HOSTEL ALLOTMENT, BANK ACCOUNT OPENING, LOCAL SUPPORT ETC</td>
                        <td className="td">TOTAL FEE</td>
                        <td className="td">INCENTIVE</td>
                    </tr>
                    {/* <!-- 2 --> */}
                    <tr> 
                        <td className="td">3500$</td>
                        <td className="td">800$</td>
                        <td className="td">2000$</td>
                        <td className="td">6300$</td>
                        <td className="td">1000</td>
                    </tr>
          </thead>
        </table>
        <p className="para border">FOOD FEE PER MONTH - 120$ (COMPULSORY)</p>
        <p className="para border pb0">ADMISSION FEE, VISA INCLUDED & FLIGHT TICKET AS PER ACTUAL</p>
      </div>

      {/* 000000000000000000000000000000000000000000000000000000000000000 */}

      <div
        className="packageForSixYear"
        data-aos="zoom-out"
        data-aos-duration="1000"
        data-aos-easing="linear"
      >
        <h3 className="packagewhite">PACKAGE FOR 2ND TO 6TH YEAR STUDENT</h3>
        <table className="table">
        <tbody>

                <tr>
                    <th className="th title2">Package</th>
                    <th className="th title2">2nd</th>
                    <th className="th title2">3rd</th>
                    <th className="th title2">4th</th>
                    <th className="th title2">5th</th>
                    <th className="th title2">6th</th>
                </tr>
                {/* <!-- 1 --> */}
                <tr>
                    <td className="td ">Tuition Fee</td>
                    <td className="td">3500$</td>
                    <td className="td">3500$</td>
                    <td className="td">3500$</td>
                    <td className="td">3500$</td>
                    <td className="td">3500$</td>
                </tr>
                {/* <!-- 2 --> */}
                <tr>
                    <td className="td ">Hostel Fee</td>
                    <td className="td">800$</td>
                    <td className="td">800$</td>
                    <td className="td">800$</td>
                    <td className="td">800$</td>
                    <td className="td">800$</td>
                </tr>
                {/* <!-- 3 --> */}
                <tr>
                    <td className="td">Medical Insurance VISA Extention</td>
                    <td className="td">200$</td>
                    <td className="td">200$</td>
                    <td className="td">200$</td>
                    <td className="td">200$</td>
                    <td className="td">200$</td>
                </tr>
                </tbody>
        </table>
      </div>

      <div className="mainSec">
        <ul>
        <li className="para"><span> IMPORTANT NOTE <b>:</b></span><br/><br/>
                    <p data-aos="zoom-out" data-aos-duration="1000" data-aos-easing="linear">
                    Due to its low-cost fee structure, Kyrgyzstan is a great option for MBBS.<br/>
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">   
                    Students who complete their MBBS degree from Bishkek International Medical University can get limitless opportunities all over the world as the degree is NMC approved and recognized worldwide. <br/>
                    </p>
                    <p data-aos="zoom-out" data-aos-duration="1000" data-aos-easing="linear">
                    over the world as the degree is NMC approved and recognized worldwide.<br/>
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">
                    At Bishkek International Medical University, the primary language for the MBBS course is English.  <br/>
                    </p>
                    <p data-aos="zoom-out" data-aos-duration="1000" data-aos-easing="linear">
                    The University has an easy and simplified admission process. <br/>
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">
                    The University provides hostels at cheaper prices.
                    </p>
                    <p data-aos="zoom-in" data-aos-duration="1000" data-aos-easing="linear">
                    BIMU is officially recognized by NMC, Ministry of Science and education of the Republic of Kazakhstan, UNESCO and WHO.
                    </p>
                </li>
        </ul>
      </div>
    </div>
  );
}
